var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-alert container"},[_c('div',{staticStyle:{"max-width":"300px","margin":"auto"}},[_c('el-alert',{attrs:{"title":_vm.message,"type":_vm.type,"description":_vm.description,"show-icon":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }